import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";

import { OPERATIONS } from "../../constants/operations.js";
import { AT_TYPES } from "../../constants/entity.js";

import { selectOperationAvailability } from "../../state/reducers/endpoints/endpointSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class AttachedSchedulesPanel extends PureComponent {
  static propTypes = {
    data: PropTypes.array,
    disabled: PropTypes.bool,
    listScheduleAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  // -- RENDER -- //

  getSchedules = () => {
    const { data, disabled, copy } = this.props;

    if (!data || data.length < 1) {
      return <p>{copy("resource.schedule_panel.empty")}</p>;
    }

    return data.map(item => {
      const { schedule } = item;

      if (!schedule) return null;

      return (
        <p key={schedule["@id"]}>
          {!disabled ? (
            <Link to={schedule["@id"]}>{schedule.name}</Link>
          ) : (
            schedule.name
          )}
        </p>
      );
    });
  };

  render() {
    const {
      disabled,
      listScheduleAvailability: { permitted, enabled },
      copy
    } = this.props;

    if (permitted !== true || enabled !== true) return null;

    return (
      <Segment disabled={disabled}>
        <Header as="h3" className="clear-both">
          {`${copy("resource.schedule_panel.title")}`}
        </Header>
        {this.getSchedules()}
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  listScheduleAvailability: selectOperationAvailability(state)(
    AT_TYPES.SCHEDULE,
    OPERATIONS.LIST
  ),

  copy: selectCopy(state)
});

export default connect(mapStateToProps)(AttachedSchedulesPanel);
